<template>
  <div>
    <div v-if="editing" class="mb-3">
      <label :for="`vimeo_id${component.id}`">Vimeo video id</label>
      <input
        type="text"
        placeholder="123456789"
        :id="`vimeo_id${component.id}`"
        v-model="vimeo"
        class="form-control"
        v-mask="'##########'"
      />
    </div>
    <div v-else-if="vimeo_id">
      <div class="ratio ratio-16x9">
        <iframe
          ref="video"
          :src="`https://player.vimeo.com/video/${vimeo_id}`"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import _ from 'lodash'

export default {
  directives: {
    mask,
  },
  props: ['component', 'editing'],
  data() {
    return {
      vimeo_id: (_.get(this.component, 'video', '/') || '/').split('/').pop(),
    }
  },
  computed: {
    vimeo: {
      get() {
        return this.vimeo_id
      },
      set(data) {
        this.vimeo_id = data
        this.component.video = `/videos/${this.vimeo_id}`
      },
    },
  },
}
</script>
